import React from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Eye } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import { ActionGroup, CountSpan } from '../SocialActions.styles';
import { formatNumber, getButtonSize } from '../utils';
export var ViewCount = function(param) {
    var viewsCount = param.viewsCount, size = param.size, showCounts = param.showCounts, labels = param.labels;
    if (!showCounts || !viewsCount || viewsCount <= 0) return null;
    return /*#__PURE__*/ React.createElement(ActionGroup, {
        small: true
    }, /*#__PURE__*/ React.createElement(Button, {
        iconOnly: true,
        size: getButtonSize(size),
        variant: "ghost",
        icon: /*#__PURE__*/ React.createElement(Eye, {
            strokeWidth: 2
        }),
        label: labels.view || '조회',
        className: "border-0 text-gray-500 dark:text-gray-300",
        animation: "none"
    }), /*#__PURE__*/ React.createElement(CountSpan, null, formatNumber(viewsCount)));
};
